import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { DateListing } from 'src/app/models/date-listing';
import { DataLakeService } from 'src/app/services/data-lake.service';
import { DisplayService } from 'src/app/services/display.service';
import { StringLocalizerService } from 'src/app/services/string-localizer.service';
import { BusinessLogicService } from 'src/app/services/business-logic.service';
import { LoggerService } from 'src/app/services/logger.service';

@Component({
    selector: 'app-run-log',
    templateUrl: './run-log.component.html',
    styleUrls: ['./run-log.component.css'],
    standalone: false
})
export class RunLogComponent implements OnInit {
  private readonly logger = inject(LoggerService);
  public tablesLoading = false;
  integrationName: string;
  integrationDisplayName: string;
  dates: DateListing[] = [];
  date: string;
  log: string[] = [];
  showNoErrors: boolean = false;
  saveIconShow: boolean = true;
  hasData: boolean = false;
  public isDrawerOpen: boolean = false;
  public strings: {} = {};
  @ViewChild('drawer', {static: false}) public drawer?: MatDrawer

  constructor(
    private dataLakeService: DataLakeService,
    private displayService: DisplayService,
    private stringLocalizerService: StringLocalizerService,
    private businessLogicService: BusinessLogicService) { 
      this.stringLocalizerService.strings.subscribe(s => {
        if(s){
          this.strings = this.stringLocalizerService.getSection("processLogs");
        }
      });
    }

 ngOnInit() {
    this.dataLakeService.$dataLakeRunData.subscribe(runData => {
      if(runData != null){
        var selectedSolutionName = this.displayService.$selectedRunLogSolution.value;
        this.integrationName = selectedSolutionName;
        this.integrationDisplayName = this.getIntegrationDisplayName(this.integrationName);
        this.displayService.setSelectedSpanText(this.integrationDisplayName);
        var selectedRunData = runData.solutionListings.find(s => s.name == selectedSolutionName);
        if(selectedRunData != null){
          this.dates = selectedRunData.dateListings;
          this.drawer?.open();
        }
      }
      else{
        this.dates = [];
        this.drawer?.open();
      }
    });
  }

  private getIntegrationDisplayName(integrationName: string): string {
    const integration = this.businessLogicService.listIntegrations().find(i => i.name === integrationName);
    return integration?.alias ?? integrationName;
  }

  // load & render a selected integration's run log
  async setData(date: string) {
    this.displayService.$selectedGrayOut.next(true);
    this.date=date;
    this.tablesLoading = true
    this.hasData = false;
    this.logger.debug('RunLogComponent', 'Loading run log', {
      operation: 'setData',
      integrationName: this.integrationName
    });
    this.log = await (await this.dataLakeService.getLog(this.integrationName, date, "RunLog")).contents;
    if(this.log.length == 0){
      this.showNoErrors = true;
      this.saveIconShow = false;
      this.displayService.$selectedGrayOut.next(false);
    }else{
      this.showNoErrors = false;
      this.saveIconShow = true;
      this.displayService.$selectedGrayOut.next(false);
    }
    this.hasData = true;
    this.displayService.$selectedGrayOut.next(false);
  }

  async selectDate(date: DateListing): Promise<void> {
    this.setDataStudioTitle(date.longDate);
    await this.setData(date.utcDate);
    this.drawer?.close();
  }

  setDataStudioTitle(title:string){
    this.displayService.setDataStudioTitle(title);
  }

  //Track when the mat-drawer is opened or closed
  onOpenedChange(event){
    this.isDrawerOpen = !this.isDrawerOpen;
  }  
    //downloads a table as json to the browser
    downloadJson(){
       this.dataLakeService
      .downloadLog(this.integrationName,this.date, "RunLog").then(blob => {
        const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(blob)
        a.href = objectUrl
        a.download = `RunLog.json`;
        a.click();
        URL.revokeObjectURL(objectUrl);
      });
    }
}
